'use client'

import { Anchor, Content, Portal, Root } from '@radix-ui/react-popover'

import { type FloatingAnchoredType } from '@/defs/floating'
import { stripProps } from '@/utils/commonUtil'

import { FloatingArrow } from '../common/FloatingArrow/FloatingArrow'
import { getFloatingContentProps } from '../common/getFloatingContentProps'
import { FloatingBox } from '../FloatingBox/FloatingBox'
import { FloatingProvider } from '../FloatingProvider/FloatingProvider'

import styles from './FloatingAnchored.module.scss'

export const FloatingAnchored = (props: FloatingAnchoredType) => {
  const { ignoreScopes, isOpen, onInteractOutside, placement, setIsOpen } = props
  const boxProps = stripProps(props, ['ignoreScopes', 'isOpen', 'onInteractOutside', 'placement', 'setIsOpen'])

  return (
    <Root onOpenChange={setIsOpen} open={isOpen}>
      <Anchor className={styles.anchor} />
      <Portal>
        <Content
          {...getFloatingContentProps({ ignoreScopes, placement })}
          onCloseAutoFocus={(e) => e.preventDefault()}
          onInteractOutside={onInteractOutside}
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <FloatingProvider setIsOpen={setIsOpen}>
            <FloatingArrow type='popover' />
            <FloatingBox {...boxProps} />
          </FloatingProvider>
        </Content>
      </Portal>
    </Root>
  )
}
